(function () {
    document.addEventListener("DOMContentLoaded", () => {
        // Shows wherever the component is placed — placement controls the page.
        const popup = document.getElementById("modal-popup");
        if (!popup) return;

        const storageKey = "popup-dismissed-" + popup.dataset.popupId;
        
        const reveal = () => popup.classList.remove("d-none");

        const dismiss = () => {
            popup.classList.add("d-none");
            try {
                localStorage.setItem(storageKey, "1");
            } catch (err) {
                // localStorage unavailable (private mode/disabled) — dismissal just won't persist.
            }
        };

        // Don't show this instance again once it's been dismissed.
        // Dismissal persists forever (localStorage), until storage is cleared or
        // the popup gets a new id. To change that behaviour:
        //   - cooldown (reappears after N days): store Date.now() instead of "1"
        //     below, and here compare against a max-age before returning.
        //   - per-session only (reappears next visit): swap localStorage -> sessionStorage.
        // if (localStorage.getItem(storageKey)) return;

        // const reveal = () => popup.classList.remove("d-none");
        // const dismiss = () => {
        //     popup.classList.add("d-none");
        //     try {
        //         localStorage.setItem(storageKey, "1");
        //     } catch (err) {
        //         // localStorage unavailable (private mode/disabled) — dismissal just won't persist.
        //     }
        // };

        // 5s delay before showing.
        setTimeout(reveal, 5000);

        const closeButton = document.getElementById("modal-popup-close-button");
        if (closeButton) closeButton.addEventListener("click", dismiss);

        // Clicking the dark backdrop (outside the content) also dismisses.
        popup.addEventListener("click", (event) => {
            if (event.target === popup) dismiss();
        });
    });
})();
